export enum UpsellBillingTrigger {
  ExchangeOrderCreated = "exchange_order_created",
  ReturnCreated = "return_created",
}
